<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">Table of Contents</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Intro#uuvm4R3VtnbK8fIMUhBKQi6">Introduction</a>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<a href="#/Text/SerialKillers#uEomKOA7fYhVW9XZDuaglIB">Serial Killers</a></div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/TheOtherJacks#uLDp6dVXMWPcuj3PBIRLpW3" title="Link target outside of Sample">The Other “Jacks”</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/TheOldWest#uB6SyRoGPkIzTZoeBfcJw3F" title="Link target outside of Sample">The Old West</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Lincoln#uuGuBWr5jtg4QGQUaRVjvuB" title="Link target outside of Sample">The Assassination of President Abraham Lincoln</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/ShortCrimeStories#u8aLWj3RDcPyJQbxZjqjic4" title="Link target outside of Sample">Short Crime Stories</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Photos#unJfnzYsY5YqUL8PCSqykJE" title="Link target outside of Sample">Photos</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?34768ce5